import styled from 'styled-components';
import { FadeInVertical } from '../../../globalStyles'

const BottomFade = FadeInVertical('bottom');

export const ModalCard = styled.div`
display: flex;
flex-flow: column nowrap;
background: white;
border-radius: 4px;
padding: 30px 20px 20px 30px;
animation: ${BottomFade} ease-out 0.3s forwards;
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
`
export const ActionRow = styled.div`
display: flex;
align-items:center;
justify-content: flex-end;
gap: 8px;
margin-top: 15px;
`
